import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';

export interface ProjectChecklist {
  id: string;
  projectId: string;
  checklistTemplateId: string;
  checklistItemId: string;
  itemQuestion: string;
  itemDisplayOrder: number;
  answer: string;
  comment?: string;
}

export interface UpsertProjectChecklistItemDto {
  checklistItemId: string;
  answer: string;
  comment?: string;
}

@Injectable({ providedIn: 'root' })
export class ProjectChecklistService {
  private apiUrl = `${environment.apiUrl}/ProjectChecklist`;

  constructor(private http: HttpClient) {}

  getByProjectAndTemplate(projectId: string, templateId: string): Observable<ProjectChecklist[]> {
    return this.http.get<ProjectChecklist[]>(`${this.apiUrl}/project/${projectId}/template/${templateId}`);
  }

  upsert(projectId: string, templateId: string, items: UpsertProjectChecklistItemDto[]): Observable<ProjectChecklist[]> {
    return this.http.post<ProjectChecklist[]>(`${this.apiUrl}/project/${projectId}/template/${templateId}/upsert`, items);
  }
}
